<div class="header-container">
  <mat-toolbar>
    @if (isOutlook) {
      <div class="toolbar-select-count" [hidden]="!isMultiSelectSupported">
        <mat-icon
          [matBadge]="selectedEmails.items.length + (selectedEmails.exceedsLimit ? '+' : '')"
          matBadgeSize="small"
          [matTooltip]="
            selectedEmails.exceedsLimit
              ? 'Limited to ' + selectedEmails.items.length + ' of ' + selectedEmails.count + ' email(s) selected'
              : selectedEmails.items.length + ' email(s) selected'
          "
          [ngClass]="{ 'grey-icon': selectedEmails.items.length === 0 }"
          >email</mat-icon
        >
      </div>
    }
    @if (isExcel) {
      <div class="toolbar-buttons toolbar-excel">
        <span class="excel-tools-label">Excel Tools</span>
        <button
          mat-icon-button
          #excelMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="excelMenu"
          aria-label="Excel Menu"
          matTooltip="Excel Menu"
        >
          <mat-icon svgIcon="excel"></mat-icon>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #excelMenu="matMenu" class="excel-tools-menu">
          <!-- Prepare Sheet Section -->
          <mat-expansion-panel (click)="$event.stopPropagation()" class="excel-menu-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>build</mat-icon>
                Prepare Sheet
              </mat-panel-title>
            </mat-expansion-panel-header>
            <button mat-menu-item (click)="excelMenuTrigger.closeMenu(); onExcelMenuActionClick('download')">
              <mat-icon>file_download</mat-icon>
              <span class="menu-item-label">
                Download
                <mat-icon matTooltip="Extract data/documents from FTF; Prepare for updating FTF data" class="menu-info-icon-end"
                  >info</mat-icon
                >
              </span>
            </button>
            <button mat-menu-item (click)="excelMenuTrigger.closeMenu(); onExcelMenuActionClick('upload')">
              <mat-icon>file_upload</mat-icon>
              <span class="menu-item-label">
                Upload
                <mat-icon matTooltip="Create new documents in FTF" class="menu-info-icon-end">info</mat-icon>
              </span>
            </button>
          </mat-expansion-panel>
          <mat-divider></mat-divider>
          <!-- Validate Sheet Section -->
          <mat-expansion-panel (click)="$event.stopPropagation()" class="excel-menu-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>check_circle</mat-icon>
                Validate Sheet
              </mat-panel-title>
            </mat-expansion-panel-header>
            <!-- Add validate sheet items here -->
          </mat-expansion-panel>
          <mat-divider></mat-divider>
          <!-- Execute Sheet Section -->
          <mat-expansion-panel (click)="$event.stopPropagation()" class="excel-menu-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>play_arrow</mat-icon>
                Execute Sheet
              </mat-panel-title>
            </mat-expansion-panel-header>
            <!-- Add execute sheet items here -->
          </mat-expansion-panel>
          <mat-divider></mat-divider>
          <!-- Additional Tools Section -->
          <mat-expansion-panel (click)="$event.stopPropagation()" class="excel-menu-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>handyman</mat-icon>
                Additional Tools
              </mat-panel-title>
            </mat-expansion-panel-header>
            <!-- Add additional tools items here -->
          </mat-expansion-panel>
        </mat-menu>
      </div>
    }
    <div class="toolbar-buttons">
      @if (showUploadButton) {
        <button mat-icon-button (click)="isOutlook || isWord ? onOpenUploadGeneric() : uploader.click()" matTooltip="Upload">
          <mat-icon>upload</mat-icon>
        </button>
      }
      <input hidden="hidden" multiple="multiple" type="file" #uploader (change)="onBrowseFiles($event)" />
      <button mat-icon-button (click)="onCookiesPreferencesClick()" matTooltip="Cookies Preferences">
        <mat-icon>cookie</mat-icon>
      </button>
      <button mat-icon-button (click)="onHelpClick()" matTooltip="Help">
        <mat-icon>help</mat-icon>
      </button>
      <button mat-icon-button [matMenuTriggerFor]="searchHistory" aria-label="History" matTooltip="History">
        <mat-icon>history</mat-icon>
      </button>
      <mat-menu #searchHistory="matMenu">
        @if (searchHistoryItems.length > 0) {
          @for (item of searchHistoryItems; track trackByItem($index, item)) {
            <button mat-menu-item (click)="onListItemClick(item)">
              <ip-icon [ipType]="item.ipType"></ip-icon>
              <span>{{ item.identifier }}</span>
            </button>
          }
        } @else {
          <button mat-menu-item disabled="">
            <span>No Items</span>
          </button>
        }
      </mat-menu>
      <button mat-icon-button [matMenuTriggerFor]="userFavorites" aria-label="Favorites" matTooltip="Favorites">
        <mat-icon>star</mat-icon>
      </button>
      <mat-menu #userFavorites="matMenu">
        @if (favoriteItems.length > 0) {
          @for (item of favoriteItems; track trackByItem($index, item)) {
            <button mat-menu-item (click)="onListItemClick(item)">
              <ip-icon [ipType]="item.ipType"></ip-icon>
              <span>{{ item.identifier }}</span>
            </button>
          }
        } @else {
          <button mat-menu-item disabled="">
            <span>No Items</span>
          </button>
        }
      </mat-menu>
      <button mat-icon-button [routerLink]="['..', 'settings']" matTooltip="Settings">
        <mat-icon>settings</mat-icon>
      </button>
      <button mat-icon-button (click)="onLogout()" matTooltip="Logout">
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <div class="search-container" [ngClass]="{ 'horizontal-search-container': orientation === 'Horizontal' }">
    <form [formGroup]="form" [ngClass]="{ 'horizontal-orientation': orientation === 'Horizontal' }">
      <mat-form-field appearance="outline" class="search-field">
        <input
          matInput
          formControlName="search"
          [matAutocomplete]="autocomplete.matAutocomplete"
          aria-label="Search for a case"
          placeholder="Search for a case"
          autocomplete="nope"
        />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline" class="ipType-field">
        <mat-select #type formControlName="ipType" class="fitcontent" panelWidth="" (selectionChange)="onIpTypeSelectionChange()">
          <mat-option value="All">All</mat-option>
          @for (type of ipTypes; track type.value) {
            <mat-option value="{{ type.key }}">{{ type.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
    <!--
    Paginated Autocomplete Component

    Inputs:
    - searchItems$: Observable stream of search result items
    - displayFn: Function that controls how each option is displayed in the dropdown
    - orientation: Layout orientation ('Horizontal' or 'Vertical')
    - paginationInfo$: Observable containing pagination metadata (page size, total, etc)

    Outputs:
    - optionSelected: Emits when user selects an autocomplete option
    - pageChange: Emits when user changes the results page

    Local Reference:
    #autocomplete: Provides access to the component's MatAutocomplete instance
    -->
    <app-paginated-autocomplete
      #autocomplete
      [searchItems$]="searchItems$"
      [displayFn]="searchDisplayFn"
      [orientation]="orientation"
      [paginationInfo$]="paginationInfo$"
      [isAll]="isAll"
      (optionSelected)="onSearchSelectionChange($event)"
      (pageChange)="onPageChange($event)"
    >
    </app-paginated-autocomplete>
  </div>
</div>
<div
  class="body-container"
  #bodyContainer
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event, bodyContainer)"
  [class.dragover]="isDragOver"
>
  @if (activeExcelMenuAction) {
    @switch (activeExcelMenuAction.action) {
      <!-- TODO: Implement Components Here For Specific Actions vs Use IP Details -->
      @case ('download') {
        @defer (when isExcel) {
          <excel-download-prepare
            [actionDetails]="activeExcelMenuAction!"
            [accessibleIpTypes]="accessibleIpTypes"
            [hasReferenceAccess]="hasReferenceAccess"
            [selectedItems]="(items$ | async) ?? []"
            (closed)="onCloseExcelMenuAction()"
          >
          </excel-download-prepare>
        }
      }
      @case ('upload') {
        <ip-detail [detail]="{ displayable: [], raw: null }" [title]="'Upload to FTF'" (closed)="onCloseExcelMenuAction()"></ip-detail>
      }
      @default {
        <ip-detail [detail]="{ displayable: [], raw: null }" [title]="'Not Implemented'" (closed)="onCloseExcelMenuAction()"></ip-detail>
      }
    }
  }
  <div
    #dropPanelContainer
    class="drop-panel"
    (dragleave)="onDragLeave($event, dropPanelContainer, ['isDropPanelOver'])"
    (dragover)="onDragOver($event, ['isDropPanelOver'])"
    (drop)="onDrop($event, ['isDragOver', 'isDropPanelOver'])"
    [class.drop-panel-dragover]="isDropPanelOver"
  >
    <p>Drop files here...</p>
  </div>

  @for (item of items$ | async; track trackByItem($index, item)) {
    <mat-accordion multi>
      <div
        #trifoldContainer
        (dragover)="onTrifoldDragOver($event, item, trifold)"
        (dragleave)="onTrifoldDragLeave($event, item, trifoldContainer)"
        (drop)="onTrifoldDrop($event, item, trifold)"
        [class.trifold-dragover]="item.state?.isDragOver"
      >
        <ip-trifold
          #trifold
          [item]="item"
          [attachActions]="isOutlookCompose"
          [widgetProductName]="widgetProductName"
          [orientation]="orientation"
          [uploadIncludeFileBrowse]="!isOutlook && !isWord"
          [canUploadNewVersion]="canUploadNewVersion"
          (closeTrifold)="onCloseItem($event)"
          (download)="onDownloadItem($event)"
          (pdfPreview)="onPdfPreview($event)"
          (openFTF)="onOpenInFTF($event)"
          (openIPMS)="onOpenInIPMS($event)"
          (refresh)="onRefreshItem($event)"
          (upload)="onOpenUploadTrifold($event)"
          (uploadVersion)="onUploadNewVersion($event)"
          (favorite)="onFavoritingCase($event)"
          (workflow)="onWorkflowEvent($event)"
          (attach)="onAttachToOutlook($event)"
          (widget)="onSendToWidget($event)"
          (expansion)="onToggleExpansion($event)"
          (tab)="onTabChange($event)"
          (view)="onViewChange($event)"
          (version)="onUpdateVersion($event)"
          (lock)="onLockItem($event)"
          (unlock)="onUnlockItem($event)"
          (undoCheckout)="onUndoCheckout($event)"
          (checkout)="onCheckout($event)"
          (updateFilters)="onUpdateFilters($event)"
          (deleteFile)="onDeleteItem($event)"
          (familyCaseClick)="onListItemClick($event)"
        />
      </div>
    </mat-accordion>
  }
</div>
<div class="version-container">
  <span>{{ version }}</span>
</div>
<ng-template #multiSelectWarning>
  <div class="multi-select-warning">
    <div matSnackBarLabel>
      <p>
        <mat-icon>warning</mat-icon>
        The FTF Outlook add-in requires Microsoft Mailbox v1.15 or higher to support multi-select of emails (<a
          target="_blank"
          href="https://learn.microsoft.com/en-us/javascript/api/requirement-sets/outlook/outlook-api-requirement-sets?view=common-js-preview&tabs=jsonmanifest#exchange-server-support"
          >see official Microsoft docs</a
        >). Your current version appears lower, which may affect usability.
      </p>
    </div>
    <div matSnackBarActions>
      <button mat-button matSnackBarAction (click)="dismissSnackbar()">Dismiss</button>
    </div>
  </div>
</ng-template>
